import { Phone } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'components/ui/tooltip';

interface VoiceCallButtonProps {
  onClick: () => void;
  disabled?: boolean;
  /** A call is already running; the button glows and stays disabled. */
  isActive?: boolean;
}

export const VoiceCallButton = ({
  onClick,
  disabled = false,
  isActive = false,
}: VoiceCallButtonProps) => {
  const { t } = useTranslation();
  const label = t('VOICE_CALL_START', { defaultValue: 'Start voice call' });

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label="Start voice call button"
            aria-pressed={isActive}
            className={`flex h-8 min-w-8 items-center justify-center sm:p-2 p-1 hover:rounded-full hover:bg-muted disabled:opacity-40 ${isActive ? 'rounded-full animate-pulse-glow' : ''}`}
            onClick={onClick}
            disabled={disabled}
          >
            <Phone
              width={20}
              height={20}
              strokeWidth={1.5}
              className="shrink-0 text-[#3D3D3D] dark:text-foreground"
            />
          </button>
        </TooltipTrigger>
        <TooltipContent side="top">{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
